/** @format */

import React, { Component } from 'react';
import { Segment, Header, Divider, Icon } from 'semantic-ui-react';
import { getDateFromTimestamp } from '../../../../helpers/getDateFromTimestamp';
import { withRouter } from 'react-router-dom';

import _ from 'lodash';
import './ClientRequests.css';

import { inject, observer } from 'mobx-react';

@inject('ClientsStore')
@observer
class ClientRequests extends Component {
  goToRequest = requestId => {
    this.props.history.push('/requests/' + requestId + '/view');
  };

  renderRequests = () => {
    const { ClientsStore } = this.props;
    let renderRequests = null;
    const clientRequests = ClientsStore.currentClient.requests;
    if (clientRequests !== undefined && clientRequests !== null) {
      const clientRequestsKeys = Object.keys(clientRequests);
      const clientRequestsValues = Object.values(clientRequests);
      let clientRequestsValuesSorted = null;
      clientRequestsValues.forEach((request, index) => {
        request.key = clientRequestsKeys[index];
      });
      if (clientRequestsValues.length > 0) {
        clientRequestsValuesSorted = _.orderBy(
          clientRequestsValues,
          ['data.timestamp'],
          ['asc'],
        );
        renderRequests = clientRequestsValuesSorted.map(request => {
          return (
            <div
              key={request.key}
              onClick={() => this.goToRequest(request.key)}
              className="client-request-link"
            >
              Richiesta di {request.reqPartsNum}&nbsp; Ricambi del&nbsp;
              {getDateFromTimestamp(Number(request.timestamp))}&nbsp;
              <Divider className="reduced-margins" />
            </div>
          );
        });
      } else {
        renderRequests = <div>Nessuna Richiesta per questo Cliente</div>;
      }
    }
    return renderRequests;
  };
  render() {
    return (
      <Segment className="reqPart-box headed-segment" padded>
        <div className="segment-header smaller">
          <Header as="h4">
            <small>
              <Icon name="list" />
            </small>
            Richieste
          </Header>
        </div>
        {this.renderRequests()}
      </Segment>
    );
  }
}

export default withRouter(ClientRequests);
